import moment from 'moment';
export const initialDocumentState = {
    participatePhoneMeeting: false,
    court: undefined,
    courtFee: 50000,
    processInterest: undefined,
    interestFromSubmitOfBPK: undefined,
    preventForkyndt: false,
    preventAutDistress: false,
    notDirectlyToCivilCourt: false,
    sendInfoToEconomyResponsible: false,
    addCourtFeeToCase: true,
    addCourtDisbursementToClientBilling: true,
    addCourtFeeToClientBilling: true,
    bpDesc: '',
    remindingDate: undefined,
    createDate: moment(),
    interestDates: '',
    interests: '',
    totalAmount: '',
    caseInterest: '',
};
export const bpkDescTemplate = `<p>Kravet vedrører nedenstående fakturaer.</p>
<p>{{debt.specification}}</p>
<p>{{#if formattedFields.financials.showInterests}}Procesrenten er beregnet 30 dage fra fakturadato i henhold til rentelovens § 3, stk. 2.{{/if}}</p>
<p>{{#if formattedFields.financials.showReminderFees}}Der er i henhold til rentelovens § 9b tillagt rykkergebyr for fremsendelse af rykkerskrivelse til debitor.{{/if}}</p>
<p>{{#if formattedFields.financials.showDebtCollectionFees}}Der er tillagt DKK {{formattedFields.financials.debtCollectionFees}} i inkassogebyr i henhold til rentelovens § 9 b, stk. 3 {{/if}}</p>
<p>{{#if case.isCompany}}{{#if formattedFields.financials.showCompensationFees}}Der er tillagt DKK {{formattedFields.financials.compensationFees}} i kompensationsbeløb i henhold til<br>rentelovens § 9 a, stk. 3.{{/if}}{{/if}}</p>
<p>{{#if formattedFields.financials.showDebtCollectionCosts}}Herudover er der i henhold til rentelovens § 9a og i overensstemmelse med bekendtgørelse nr. 719 af 03.06.2024 tillagt DKK {{formattedFields.financials.debtCollectionCosts}} i inkassoomkostninger for udenretlig inddrivelse ved inkassovirksomheden {{collector.name}}, {{collector.address.address}}, {{collector.address.zipcode}} {{collector.address.city}}.{{/if}}</p>
<p>Den udenretlige inddrivelse har bestået i skriftlig henvendelse til debitor.</p>`;
export const getDocumentsFromStorage = () => {
    // Old place to store the document data
    const LocalModelDocuments = localStorage.LocalModel && JSON.parse(localStorage.LocalModel);
    const localStorageDocuments = localStorage.GLbetalingspaakrav &&
        JSON.parse(localStorage.GLbetalingspaakrav);
    return (LocalModelDocuments && LocalModelDocuments.GLbetalingspaakrav) ||
        localStorageDocuments
        ? {
            ...(LocalModelDocuments && LocalModelDocuments.GLbetalingspaakrav),
            ...localStorageDocuments,
        }
        : null;
};
let tId;
const onlyStoreTheseKeysInLocalStorage = {
    bpDesc: true,
    notDirectlyToCivilCourt: true,
    processInterest: true,
    interestFromSubmitOfBPK: true,
    sendInfoToEconomyResponsible: true,
    addCourtFeeToCase: true,
    addCourtDisbursementToClientBilling: true,
    addCourtFeeToClientBilling: true,
    preventForkyndt: true,
    preventAutDistress: true,
    participatePhoneMeeting: true,
};
export const setLocalModel = (data) => {
    clearTimeout(tId);
    tId = setTimeout(() => {
        const d = {};
        Object.entries(data).map(([key, data]) => {
            if (onlyStoreTheseKeysInLocalStorage[key]) {
                d[key] = data;
            }
        });
        localStorage.setItem('GLbetalingspaakrav', JSON.stringify(d));
    }, 500);
};
//# sourceMappingURL=index.js.map